<template>
  <div>
    <div class="img_box">
      <img src="../../assets/images/wxPay.png" alt="" />
      <div class="name">支付成功</div>
    </div>
    <div class="but" @click="onNext">返回首页</div>
  </div>
</template>

<script>
export default {
  onReady() {
    let mchData = {
      action: "onIframeReady",
      displayStyle: "SHOW_CUSTOM_PAGE"
    };
    let postData = JSON.stringify(mchData);
    parent.postMessage(postData, "*");
  },
  methods: {
    onNext() {
      location.href = "https://jn010665.jinnuo888.top";
    }
  }
};
</script>

<style scoped>
.img_box {
  text-align: center;
  margin-top: 2rem;
}

img {
  width: 2rem;
}

.name {
  color: #09bb07;
  margin-top: 0.2rem;
  font-size: 0.4rem;
}

.but {
  width: 90%;
  margin: auto;
  background-color: #09bb07;
  color: #fff;
  border-radius: 5px;
  text-align: center;
  padding: 15px;
  margin-top: 4rem;
}
</style>
